import React from 'react';

export const BrixLogoLaYes = ({ className }) => (
    <svg className={className} viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_135_801" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="91" y="92" width="184" height="184">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M136.962 92L91 137.962L137 183.962L91 229.962L136.962 275.924L182.962 229.924L183 229.962L210.185 257.147L228.962 275.924L274.924 229.962L256.147 211.185L228.962 184L228.924 183.962L228.962 183.924L250.901 161.985L274.924 137.962L228.962 92L204.939 116.023L183 137.962L182.962 138L136.962 92Z" fill="#D9F5D9" />
        </mask>
        <g mask="url(#mask0_135_801)">
            <rect x="72" y="78" width="221" height="213" fill="url(#paint0_linear_135_801)" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
            <rect x="137" y="183.962" width="65" height="65" transform="rotate(-45 137 183.962)" fill="#CCCCCC" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
            <rect x="183" y="137.962" width="65" height="65" transform="rotate(-45 183 137.962)" fill="#F0F1F3" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
            <rect x="91" y="137.962" width="65" height="65" transform="rotate(-45 91 137.962)" fill="#F0F1F3" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
            <rect x="91" y="229.962" width="65" height="65" transform="rotate(-45 91 229.962)" fill="#F0F1F3" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
            <rect x="183" y="229.962" width="65" height="65" transform="rotate(-45 183 229.962)" fill="#F0F1F3" />
        </g>
        <defs>
            <linearGradient id="paint0_linear_135_801" x1="72" y1="184.5" x2="293" y2="184.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#00BA00" />
                <stop offset="1" stop-color="#009FDA" />
            </linearGradient>
        </defs>
    </svg>
)